import { allCommodities } from 'helpers/fakeData';

export const useGetCommodity = (id: string) => {
  const commodity = allCommodities.find((commodity) => commodity.id === id);
  return {
    commodity,
    isLoading: false,
    error: null,
  };
};
